export default __webpack_public_path__ + "static/images/web-app.2232057d.png";